import React, { Component, Children } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { replace } from 'react-router-redux';
import qs from 'qs';

import { flashErrorMessage } from '../../actions/flash';
import { fetchM } from '../../actions/fetchM';
import { fetchAppConfig } from '../../actions/appConfig';
import isNumber from '../../utils/numbers/isNumber';
import { checkChanges } from '../../utils/checkChanges';
import {
  NEW_CUSTOMER_PROMPT,
} from '../../constants/promptMessages';

import List from './List';
import Overview from './Overview';
import CreditCheck from './CreditCheck';
import ManageCreditCheck from '../CreditCheck/Manage';
import ManageCreditCheckSettings from '../CreditCheck/ManageSettings';
import MultipleEntity from '../CreditCheck/MultipleEntity';
import EditIncome from './EditIncome';
import NewEditIncome from './NewEditIncome';
import New from './New';


class Customers extends Component {
  static propTypes = {
    appConfig: PropTypes.shape({
      data: PropTypes.shape({
        customerOwnedByDeveloperExecutive: PropTypes.bool,
      }),
    }),
    auth: PropTypes.shape({
      isBranchLeader: PropTypes.bool,
      isHeadquarters: PropTypes.bool,
      isDeveloper: PropTypes.bool,
      isSuperAdmin: PropTypes.bool,
    }),
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
    children: PropTypes.node,
    location: PropTypes.shape({
      pathname: PropTypes.string,
      query: PropTypes.object,
    }),
  }
  static contextTypes = {
    store: PropTypes.object,
  }
  static mapStateToProps = state => ({
    appConfig: state.appConfig,
    auth: state.auth,
  })

  static List = List
  static Overview = checkChanges(Overview)
  static CreditCheck = checkChanges(CreditCheck)
  static ManageCreditCheck = checkChanges(ManageCreditCheck)
  static ManageCreditCheckSettings = checkChanges(ManageCreditCheckSettings)
  static MultipleEntity = checkChanges(MultipleEntity)
  static EditIncome = checkChanges(EditIncome)
  static NewEditIncome = checkChanges(NewEditIncome)
  static New = checkChanges(New, { message: NEW_CUSTOMER_PROMPT })

  constructor(props) {
    super(props);
    this.state = {
      token: null,
      count: 0,
      limit: 0,
      offset: 0,
      loading: true,
      data: [],
    };
  }

  componentWillMount() {
    const { store } = this.context;
    store.dispatch(fetchAppConfig()).then(() => {
      if (
        !this.props.auth.isSuperAdmin &&
        !this.props.auth.isHeadquarters &&
        !this.props.auth.isBranchLeader &&
        !this.hasAccessDE()
      ) {
        store.dispatch(replace('/forbidden/'));
      }
    });
  }

  componentDidMount() {
    const { query } = this.props.location;
    this.fetchCustomers(query);
    if (!this.props.params.id) {
      if (!isNumber(query.page) || query.page <= 0) {
        delete query.page;
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    const { pathname, query } = nextProps.location;
    if (!pathname.includes('/new/')) {
      if (!this.state.loading) {
        this.fetchCustomers(query);
      }
    }
  }

  setCustomers(data = []) {
    return new Promise((res) => {
      this.setState({
        data: data || [],
      }, () => {
        res(data);
      });
    });
  }

  setComponentState(state = {}) {
    return new Promise((res) => {
      this.setState(state, () => {
        res(state);
      });
    });
  }

  setLoading(loading = false) {
    return new Promise((res) => {
      this.setState({ loading }, () => {
        res(loading);
      });
    });
  }

  hasAccessDE() {
    const { auth, appConfig } = this.props;
    if (auth &&
      auth.companyBranch &&
      !auth.companyBranch.isExternal &&
      appConfig &&
      appConfig.data &&
      appConfig.data.customerOwnedByDeveloperExecutive
    ) {
      return true;
    }
    return false;
  }

  async fetchCustomers(q) {
    await this.setLoading(true);
    const { store } = this.context;
    const query = Object.assign({}, q);
    if (!this.props.params.id) {
      if (!query.page || !isNumber(query.page) || query.page <= 0) {
        query.page = 1;
      }
    }
    let res;
    try {
      let url = '/customers/';
      if (this.props.params.id) {
        url += `${this.props.params.id}/`;
      } else {
        query.showBookingCount = true;
      }
      let queryString = '';
      if (qs.stringify(query)) {
        queryString = `?${qs.stringify(query)}`;
      }
      res = await store.dispatch(fetchM(`${url}${queryString}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: 'An error occurred, please refresh page' }));
      await this.setLoading(false);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const token = res.headers.get('X-Csrf-Token');
      const count = parseInt(res.headers.get('M-Data-count'), 10);
      const limit = parseInt(res.headers.get('M-Data-limit'), 10);
      const offset = parseInt(res.headers.get('M-Data-offset'), 10);
      const data = await res.json();
      // handle token
      await this.setComponentState({
        token,
        count,
        limit,
        offset,
        data,
      });
      if (!this.props.params.id) {
        await this.setCustomers(data);
      }
    }
    await this.setLoading(false);
  }

  renderChild() {
    return Children.map(this.props.children, child => (
      React.cloneElement(child, {
        token: this.state.token,
        count: this.state.count,
        limit: this.state.limit,
        offset: this.state.offset,
        loading: this.state.loading,
        data: this.state.data,
      })
    ));
  }

  render() {
    return (
      <div>
        {this.renderChild()}
      </div>
    );
  }
}

export default connect(Customers.mapStateToProps)(Customers);



// WEBPACK FOOTER //
// ./src/containers/Customers/Customers.jsx